import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";

const HomeCarousel = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <div>
      <Carousel touch={true} activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://mdbootstrap.com/img/Photos/Others/city8.jpg"
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Inspire Code & Graphics</h3>
            <p>
              We create beautiful Graphics, Functional website, Visual effects.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://mdbootstrap.com/img/Photos/Others/city9.jpg"
            alt="Second slide"
          />

          <Carousel.Caption>
            <h3>Inspire Code & Graphics</h3>
            <p>
              We create beautiful Graphics, Functional website, Visual effects.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src="https://mdbootstrap.com/img/Photos/Others/city9.jpg"
            alt="Third slide"
          />

          <Carousel.Caption>
            <h3>Inspire Code & Graphics</h3>
            <p>
              We create beautiful Graphics, Functional website, Visual effects.
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export default HomeCarousel;
